import { Injectable, Injector } from '@angular/core';
import { environment } from '@env/environment';
import { ConstantsService } from '@app/shared/constants.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Logger } from '@app/core/logger.service';

/**
 * Logger declaration and initialisation.
 */
const log = new Logger('ClientResources');

/**
 * The Client Resources service instance.
 */
@Injectable()
export class ClientResources {
  translate: any;
  production = true;
  private authUrl: string;
  private serverBaseUrl: string;
  private georgeUrl: any;
  private georgeBusinessUrl: any;
  private appCodes: any;
  private loginAction: string;
  private threatmarkUrl: string;
  private serverTimeout: number;

  /**
   * The constructor instance of the Client Resources service.
   *
   * @param http The injected instance of the Http Client service.
   * @param injector The injected instance of the Injector service.
   * @param constantsService The injected instance of the Constants service.
   */
  constructor(
    private readonly http: HttpClient,
    private readonly injector: Injector,
    private readonly constantsService: ConstantsService
  ) {}

  /**
   * Load method.
   *
   * @returns Promise who represents the completion of an asynchronous operation.
   */
  load(): Promise<any> {
    log.info('load api', ConstantsService.urlContext.ClientSettingsk8s);
    const router = this.injector.get(Router);

    return new Promise((resolve, reject) => {
      this.http.get(ConstantsService.urlContext.ClientSettingsk8s).subscribe(
        (response) => {
          log.info('success api', response);
          this.mapClientResources(response);
          resolve(true);
        },
        (error) => {
          if (environment.local) {
            log.info('error api => enviroment.local', error);
            this.mapClientResources(environment);

            return resolve(true);
          } else {
            log.info('error api => !enviroment.local', error);
            router.navigate(['error']);

            return resolve(false);
          }
        }
      );
    });
  }

  /**
   * The map client resources method.
   *
   * @param obj The obj identifier
   */
  mapClientResources(obj: any): void {
    if (obj.hasOwnProperty('publicKey')) {
      this.constantsService.setPublicKey(obj.publicKey);
    }
    if (obj.hasOwnProperty('serverBaseUrl')) {
      this.setBaseUrl(obj.serverBaseUrl);
    }
    if (obj.hasOwnProperty('authBaseUrl')) {
      this.setAuthUrl(obj.authBaseUrl);
    }
    if (obj.hasOwnProperty('georgeBaseUrl')) {
      this.setGeorgeUrl(obj.georgeBaseUrl);
    }
    if (obj.hasOwnProperty('loginCodes')) {
      this.setAppCodes(obj.loginCodes);
    }
    if (obj.hasOwnProperty('loginAction')) {
      this.setLoginAction(obj.loginAction);
    }
    if (obj.hasOwnProperty('georgeBusinessUrl')) {
      this.setGeorgeBusinessUrl(obj.georgeBusinessUrl);
    }
    if (obj.hasOwnProperty('threatmarkUrl')) {
      this.setThreatmarkUrl(obj.threatmarkUrl);
    }
    if (obj.hasOwnProperty('serverTimeout')) {
      this.setServerTimeout(obj.serverTimeout);
    }
  }

  /**
   * Get app codes method.
   *
   * @returns any.
   */
  getAppCodes() {
    return this.appCodes;
  }

  /**
   * The set app codes method.
   *
   * @param value The value identifier.
   */
  setAppCodes(value: any): void {
    this.appCodes = value;
  }

  /**
   * Get auth url method.
   *
   * @returns String.
   */
  getAuthUrl(): string {
    return this.authUrl;
  }

  /**
   * Set auth url method.
   *
   * @param value The value identifier.
   */
  setAuthUrl(value: string): void {
    this.authUrl = value;
  }

  /**
   * Get george url method.
   *
   * @returns any
   */
  getGeorgeUrl() {
    return this.georgeUrl;
  }

  /**
   * get server timeout
   */
  getServerTimeout(): number {
    return this.serverTimeout;
  }

  /**
   *
   * @param value
   */
  setServerTimeout(value: number): void {
    this.serverTimeout = value;
  }

  /**
   * Set george url method.
   *
   * @param value The value identifier.
   */
  setGeorgeUrl(value: string): void {
    this.georgeUrl = value;
  }

  /**
   * Get george business url method.
   *
   * @returns any
   */
  getGeorgeBusinessUrl() {
    return this.georgeBusinessUrl;
  }

  /**
   * Set george business url method.
   *
   * @param value The value identifier.
   */
  setGeorgeBusinessUrl(value: string): void {
    this.georgeBusinessUrl = value;
  }

  /**
   * Get threatmark url method.
   */
  getThreatmarkUrl() {
    return this.threatmarkUrl;
  }

  /**
   * Set threatmark url method.
   *
   * @param value The value identifier.
   */
  setThreatmarkUrl(value: string): void {
    this.threatmarkUrl = value;
  }

  /**
   * Gets the  login url
   */
  getLoginAction() {
    return this.loginAction;
  }

  /**
   * Set the login url
   *
   * @param value The value identifier
   */
  setLoginAction(value: string) {
    this.loginAction = value;
  }

  getBaseUrl() {
    return this.serverBaseUrl;
  }

  /**
   * Set base url method.
   *
   * @param value The value identifier.
   */
  setBaseUrl(value: string): void {
    this.serverBaseUrl = value;
  }

  /**
   * Get production method.
   *
   * @returns Boolean
   */
  getProduction(): boolean {
    return this.production;
  }

  /**
   * Set production method.
   *
   * @param value The value identifier.
   */
  setProduction(value: boolean): void {
    this.production = value;
  }
}
